import type { ReactNode } from "react";

/** KPI number 28/32 800 tabular (spec 10 §2); `danger` for overdue counts, always with text, never colour alone. */
export const KpiTile = ({
  label,
  value,
  hint,
  tone = "default",
}: {
  label: string;
  value: ReactNode;
  hint?: ReactNode;
  tone?: "default" | "danger";
}) => (
  <div
    role="group"
    aria-label={label}
    className="min-w-0 rounded-xl border bg-card px-4 py-3 shadow-[0_1px_3px_rgba(0,0,0,.06),0_8px_24px_-12px_rgba(0,0,0,.12)]"
  >
    <p className="line-clamp-2 text-[11px] font-bold uppercase tracking-[.08em] text-muted-foreground">
      {label}
    </p>
    <p
      className={`break-words text-[22px] font-extrabold leading-7 tabular-nums sm:text-[28px] sm:leading-8 ${tone === "danger" ? "text-destructive" : ""}`}
    >
      {value}
    </p>
    {hint && <p className="text-xs text-muted-foreground">{hint}</p>}
  </div>
);
